{
  "collapse": "Skjul",
  "expand": "Udvid"
}
